<template>
	<div>
		<template v-if="middle">
			<a :href="right_500_500 ? right_500_500.adLink : ''" target="_blank">
				<v-img
					contain
					max-width="500"
					class="mx-auto grey lighten-3"
					:src="right_500_500 ? right_500_500.adPhoto : ''"
					:aspect-ratio="500/500"
				>
					<template #placeholder>
						<v-row class="fill-height ma-0" align="center" justify="center">
							<v-progress-circular indeterminate color="primary"></v-progress-circular>
						</v-row>
					</template>
				</v-img>
			</a>
		</template>

		<template v-else-if="max">
			<v-row no-gutters>
				<v-col cols="12" class="pa-0">
					<a :href="top_728_90 ? top_728_90.adLink : ''" target="_blank">
						<v-img
							contain
							:aspect-ratio="728/90"
							class="mx-auto grey lighten-3"
							:src="top_728_90 ? top_728_90.adPhoto : ''"
						>
							<template #placeholder>
								<v-row class="fill-height ma-0" align="center" justify="center">
									<v-progress-circular indeterminate color="primary"></v-progress-circular>
								</v-row>
							</template>
						</v-img>
					</a>
				</v-col>
			</v-row>
		</template>

		<template v-else-if="stickyBottom">
			<v-bottom-navigation
				class="elevation-0 v-card--outlined v-card"
				app
				height="auto"
				min-height="30"
			>
				<a :href="top_728_90 ? top_728_90.adLink : ''" target="_blank" class="red" style="width: 100%">
					<v-img
						contain
						:aspect-ratio="728/90"
						class="mx-auto grey lighten-3"
						:src="top_728_90 ? top_728_90.adPhoto : ''"
					>
						<template #placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular indeterminate color="primary"></v-progress-circular>
							</v-row>
						</template>
					</v-img>
				</a>
			</v-bottom-navigation>
		</template>

		<v-banner v-else class="transparent ltr full-width" flat>
			<v-container class="py-0">
				<v-row no-gutters>
					<v-col cols="12" class="pa-0">
						<a :href="top_728_90 ? top_728_90.adLink : ''" target="_blank">
							<v-img
								contain
								:aspect-ratio="728/90"
								max-width="728"
								class="mx-auto grey lighten-3"
								:src="top_728_90 ? top_728_90.adPhoto : ''"
							>
								<template #placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-row>
								</template>
							</v-img>
						</a>
					</v-col>
				</v-row>
			</v-container>
		</v-banner>
	</div>
</template>

<script>
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";

export default {
	props: {
		middle: {
			type: Boolean,
			default: false
		},
		max: {
			type: Boolean,
			default: false
		},
		stickyBottom: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			right_500_500: null,
			top_728_90: null,
		};
	},
	mounted() {
		if (this.middle) {
			this.get_right_500_500();
		} else {
			this.get_top_728_90();
		}
	},
	methods: {
		get_right_500_500() {
			client
				.get("/api/unspokenname/rightad/250x250")
				.then(response => {
					console.log(response);
					this.right_500_500 = this.prepareAd(response.data);
				})
				.catch(err => {
					console.log(err);
					this.right_500_500 = this.prepareFakeAd();
				});
		},
		get_top_728_90() {
			client
				.get("/api/unspokenname/topad/728x90")
				.then(response => {
					console.log(response);
					this.top_728_90 = this.prepareAd(response.data);
				})
				.catch(err => {
					console.log(err);
					this.top_728_90 = this.prepareFakeAd();
				});
		},
		prepareAd(ad) {
			var newAd = ad;
			newAd.adLink = addBaseURL(newAd.adLink);
			newAd.adPhoto = addBaseURL(newAd.adPhoto);
			// unused props:
			// description
			// title
			return newAd;
		},
		prepareFakeAd() {
			var newAd = {};
			var hash = "";
			if (window.location.hash) {
				hash = "#";
			}
			newAd.adLink = document.location.origin + hash + this.$router.matcher.match({name: "dashboard-ads-add"}).fullPath;
			newAd.adPhoto = addBaseURL('/storage/logo.png');

			return newAd;
		}
	}
};
</script>

<style scoped>
.full-width ::v-deep .v-banner__text {
	width: 100% !important;
}

.full-width ::v-deep .v-banner__wrapper {
	border-bottom: 0 !important;
}

.v-responsive ::v-deep .v-responsive__content {
	margin-right: 0px !important;
	min-width: 100%;
}
div ::v-deep .v-responsive {
	border: thin solid rgba(0, 0, 0, 0.12) !important;
	border-radius: 4px;
}
</style>